import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiWrapperTableComponent } from './fi-wrapper-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { FiWrapperTableSpanCellComponent } from './cells/fi-wrapper-table-span-cell/fi-wrapper-table-span-cell.component';
import { FiWrapperTableACellComponent } from './cells/fi-wrapper-table-a-cell/fi-wrapper-table-a-cell.component';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiWrapperTableMatMenuCellComponent } from './cells/fi-wrapper-table-mat-menu-cell/fi-wrapper-table-mat-menu-cell.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiWrapperTableFavoriteToggleCellComponent } from './cells/fi-wrapper-table-favorite-toggle-cell/fi-wrapper-table-favorite-toggle-cell.component';
import { FiWrapperTableTimeCellComponent } from './cells/fi-wrapper-table-time-cell/fi-wrapper-table-time-cell.component';
import { FiWrapperTablePreviewImageCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-preview-image-cell/fi-wrapper-table-preview-image-cell.component';
import { FiWrapperTableCustomSortIconComponent } from './cells/fi-wrapper-table-custom-sort-icon/fi-wrapper-table-custom-sort-icon.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiWrapperTableContactsCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-contacts-cell/fi-wrapper-table-contacts-cell.component';
import { FiWrapperGridComponent } from './fi-wrapper-grid/fi-wrapper-grid.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiWrapperTableSpanArrayCellComponent } from './cells/fi-wrapper-table-span-array-cell/fi-wrapper-table-span-array-cell.component';
import { FiWrapperTableChangedOnCellComponent } from './cells/fi-wrapper-table-changed-on-cell/fi-wrapper-table-changed-on-cell.component';
import { FiWrapperTableCreatedByCellComponent } from './cells/fi-wrapper-table-created-by-cell/fi-wrapper-table-created-by-cell.component';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiWrapperTablePublishedCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-published-cell/fi-wrapper-table-published-cell.component';
import { FiWrapperTableHtmlCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-html-cell/fi-wrapper-table-html-cell.component';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiWrapperTableRollupContentCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-rollup-content-cell/fi-wrapper-table-rollup-content-cell.component';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { FiWrapperTableDateByUserIdCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-date-by-user-id-cell/fi-wrapper-table-date-by-user-id-cell.component';
import { FiWrapperTableItemProfileCellComponent } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-item-profile-cell/fi-wrapper-table-item-profile-cell.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiWrapperTableSuperAdminIconCellComponent } from './cells/fi-wrapper-table-super-admin-icon-cell/fi-wrapper-table-super-admin-icon-cell.component';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatRippleModule,
        FiStateSrefModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        FiEmptyListModule,
        FiLoadingModule,
        FiAppTextSharedModule,
        FiMatIconCheckboxMenuModule,
        MatDividerModule,
        FiFormatDateModule,
        FiLineClampModule,
        FiBindHtmlCompileModule,
        FiRollupContentModule,
        FiProfileIconModule,
    ],
    declarations: [
        FiWrapperTableComponent,
        FiWrapperTableSpanCellComponent,
        FiWrapperTableACellComponent,
        FiWrapperTableMatMenuCellComponent,
        FiWrapperTableFavoriteToggleCellComponent,
        FiWrapperTableTimeCellComponent,
        FiWrapperTablePreviewImageCellComponent,
        FiWrapperTableCustomSortIconComponent,
        FiWrapperTableContactsCellComponent,
        FiWrapperGridComponent,
        FiWrapperTableSpanArrayCellComponent,
        FiWrapperTableChangedOnCellComponent,
        FiWrapperTableCreatedByCellComponent,
        FiWrapperTableDateByUserIdCellComponent,
        FiWrapperTableItemProfileCellComponent,
        FiWrapperTablePublishedCellComponent,
        FiWrapperTableHtmlCellComponent,
        FiWrapperTableRollupContentCellComponent,
        FiWrapperTableSuperAdminIconCellComponent,
    ],
    exports: [
        FiWrapperTableComponent,
        FiWrapperGridComponent,
        FiWrapperTableSpanCellComponent,
        FiWrapperTableACellComponent,
        FiWrapperTableMatMenuCellComponent,
        FiWrapperTableFavoriteToggleCellComponent,
        FiWrapperTableTimeCellComponent,
        FiWrapperTablePreviewImageCellComponent,
        FiWrapperTableCustomSortIconComponent,
        MatTableModule,
        MatSortModule,
        FiWrapperTableContactsCellComponent,
        FiWrapperTableSpanArrayCellComponent,
        FiWrapperTableChangedOnCellComponent,
        FiWrapperTableCreatedByCellComponent,
        FiWrapperTableDateByUserIdCellComponent,
        FiWrapperTableItemProfileCellComponent,
        FiWrapperTablePublishedCellComponent,
        FiWrapperTableHtmlCellComponent,
        FiWrapperTableRollupContentCellComponent,
        FiWrapperTableSuperAdminIconCellComponent,
    ],
})
export class FiWrapperTableModule {}
